import axios from 'axios';
import { logger } from '../utility/logger';

// Override the default error handling
const originalConsoleError = console.error;
console.error = (...args) => {
    // Check if this is an axios error
    if (args[0]?.includes?.('uncaught') && args[1]?.isAxiosError) {
        // For axios errors, just log them quietly
        logger(`API Error: ${args[1].config?.url || 'Unknown URL'}`, 'error');
        return;
    }
    // For all other errors, use the original console.error
    originalConsoleError.apply(console, args);
};

// Add a response interceptor
axios.interceptors.response.use(
    response => response,
    error => {
        // Log error in development mode
        if (process.env.NODE_ENV === 'development') {
            logger(`API Error: ${error.config?.url || 'Unknown URL'}`, 'error');
            console.log('Error details:', {
                url: error.config?.url,
                method: error.config?.method,
                status: error.response?.status,
                data: error.response?.data
            });
        }

        // Return a rejected promise that won't trigger the default error handler
        return new Promise((_, reject) => {
            reject(Object.assign(error, { __handled: true }));
        });
    }
);

// Global error handler for unhandled rejections
window.addEventListener('unhandledrejection', event => {
    if (event.reason?.__handled || event.reason?.isAxiosError) {
        event.preventDefault();
        return false;
    }
});

// Also handle errors in development
if (process.env.NODE_ENV === 'development') {
    window.addEventListener('error', event => {
        if (event.error?.isAxiosError || event.error?.__handled) {
            event.preventDefault();
            return false;
        }
    });
}

export default axios;
